import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb0011',
    ecrans: ['00-2'],
    params: [
        '?pveann',
        '?intcleint',
        '?prucleint',
        '?poscleint',
        '?demcleint',
        '?vaepcstyp'
    ]
});